import type { CageWinchMeta } from './types';

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

function asFiniteNumber(value: unknown): number | null {
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function asBoolean(value: unknown): boolean | null {
    return typeof value === 'boolean' ? value : null;
}

export function mapCageWinchToDomain(raw: unknown): CageWinchMeta | null {
    if (!isRecord(raw)) {
        return null;
    }

    const bioscopeId = asFiniteNumber(raw.bioscopeId);
    const winchId = asFiniteNumber(raw.winchId);
    const winchExists = asBoolean(raw.winchExists);
    if (bioscopeId == null || winchId == null || winchExists == null) {
        return null;
    }

    return { bioscopeId, winchId, winchExists };
}
